import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import bs from 'react-intl/locale-data/bs';
import hr from 'react-intl/locale-data/hr';
import messagesEn from './messages/messages_en';
import messagesBs from './messages/messages_bs';
import messagesHr from './messages/messages_hr';
import { flattenMessages } from './messages/utils';

addLocaleData([...en, ...bs, ...hr]);

window.$locale = null;

const { Provider, Consumer } = React.createContext();

class IntlProviderWrapper extends React.Component {
    constructor(...args) {
        super(...args);

        this.switchToEnglish = () => {
            this.setState({ locale: 'en', messages: messagesEn });
            window.$locale = 'en';
        };

        this.switchToBosnian = () => {
            this.setState({ locale: 'bs', messages: messagesBs });
            window.$locale = 'bs';
        };

        this.switchToCroatian = () => {
            this.setState({ locale: 'hr', messages: messagesHr });
            window.$locale = 'hr';
        };

        // pass everything in state to avoid creating object inside render method (like explained in the documentation)
        this.state = {
            locale: null,
            messages: messagesBs,
            switchToEnglish: this.switchToEnglish,
            switchToBosnian: this.switchToBosnian,
            switchToCroatian: this.switchToCroatian
        };
    }

    render() {
        const { children } = this.props;
        const { locale, messages } = this.state;
        return (
            <Provider value={this.state}>
                <IntlProvider
                    key={locale}
                    locale={locale}
                    messages={flattenMessages(messages)}
                    defaultLocale="bs"
                >
                    {children}
                </IntlProvider>
            </Provider>
        );
    }
}

export { IntlProviderWrapper as IntlProvider, Consumer as IntlConsumer };



// WEBPACK FOOTER //
// ./src/IntlContext.js